import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgJcb = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 33,
	height: 33,
	viewBox: "0 0 33 33",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_3886_27657)",
		children: [/* @__PURE__ */ _jsx("rect", {
			x: -2,
			y: -2,
			width: 38,
			height: 38,
			fill: "white"
		}), /* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip1_3886_27657)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M32.8931 24.4693C32.8931 27.1894 30.6781 29.4044 27.958 29.4044H1.10645V9.85828C1.10645 7.13815 3.32141 4.92319 6.04154 4.92319H32.8931V24.4693Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M24.1494 19.4564H26.1895C26.2478 19.4564 26.3838 19.437 26.4421 19.437C26.8307 19.3593 27.161 19.0096 27.161 18.5238C27.161 18.0575 26.8307 17.7078 26.4421 17.6106C26.3838 17.5912 26.2672 17.5912 26.1895 17.5912H24.1494V19.4564Z",
					fill: "url(#paint0_linear_3886_27657)"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.957 6.57468C24.014 6.57468 22.4208 8.14847 22.4208 10.1108V13.783H27.4142C27.5308 13.783 27.6668 13.783 27.7639 13.8025C28.8908 13.8607 29.7263 14.4436 29.7263 15.454C29.7263 16.2506 29.1628 16.9306 28.1136 17.0666V17.1055C29.26 17.1832 30.1343 17.8244 30.1343 18.8153C30.1343 19.8839 29.1628 20.5833 27.8805 20.5833H22.4014V27.7723H27.589C29.532 27.7723 31.1252 26.1985 31.1252 24.2361V6.57468H25.957Z",
					fill: "url(#paint1_linear_3886_27657)"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M26.9084 15.6871C26.9084 15.2208 26.5781 14.9099 26.1895 14.8516C26.1507 14.8516 26.0535 14.8322 25.9952 14.8322H24.1494V16.542H25.9952C26.0535 16.542 26.1701 16.542 26.1895 16.5226C26.5781 16.4643 26.9084 16.1534 26.9084 15.6871Z",
					fill: "url(#paint2_linear_3886_27657)"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M6.41205 6.57465C4.46909 6.57465 2.87587 8.14844 2.87587 10.1108V18.8347C3.86678 19.3204 4.89654 19.6313 5.92631 19.6313C7.15037 19.6313 7.81097 18.893 7.81097 17.8826V13.7636H10.842V17.8632C10.842 19.4564 9.85107 20.7582 6.48976 20.7582C4.44966 20.7582 2.85645 20.3113 2.85645 20.3113V27.7528H8.04412C9.98707 27.7528 11.5803 26.179 11.5803 24.2166V6.57465H6.41205Z",
					fill: "url(#paint3_linear_3886_27657)"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M16.1846 6.57465C14.2417 6.57465 12.6484 8.14844 12.6484 10.1108V14.735C13.5422 13.9773 15.0966 13.4915 17.603 13.6081C18.9436 13.6664 20.3814 14.0356 20.3814 14.0356V15.5316C19.6625 15.1625 18.8076 14.8322 17.7001 14.7545C15.796 14.6185 14.6497 15.5511 14.6497 17.1832C14.6497 18.8347 15.796 19.7673 17.7001 19.6118C18.8076 19.5341 19.6625 19.1844 20.3814 18.8347V20.3307C20.3814 20.3307 18.963 20.6999 17.603 20.7582C15.0966 20.8748 13.5422 20.389 12.6484 19.6313V27.7917H17.8361C19.7791 27.7917 21.3723 26.2179 21.3723 24.2555V6.57465H16.1846Z",
					fill: "url(#paint4_linear_3886_27657)"
				})
			]
		})]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_3886_27657",
			x1: 22.4169,
			y1: 18.5261,
			x2: 31.148,
			y2: 18.5261,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "#007940" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .2285,
					stopColor: "#00873F"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .7433,
					stopColor: "#40A737"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#5CB531"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_3886_27657",
			x1: 22.4173,
			y1: 17.165,
			x2: 31.1491,
			y2: 17.165,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "#007940" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .2285,
					stopColor: "#00873F"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .7433,
					stopColor: "#40A737"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#5CB531"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint2_linear_3886_27657",
			x1: 22.4167,
			y1: 15.6847,
			x2: 31.1482,
			y2: 15.6847,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "#007940" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .2285,
					stopColor: "#00873F"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .7433,
					stopColor: "#40A737"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#5CB531"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint3_linear_3886_27657",
			x1: 2.87176,
			y1: 17.165,
			x2: 11.738,
			y2: 17.165,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "#1F286F" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .4751,
					stopColor: "#004E94"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .8261,
					stopColor: "#0066B1"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#006FBC"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint4_linear_3886_27657",
			x1: 12.5982,
			y1: 17.165,
			x2: 21.2094,
			y2: 17.165,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "#6C2C2F" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .1735,
					stopColor: "#882730"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .5731,
					stopColor: "#BE1833"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .8585,
					stopColor: "#DC0436"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#E60039"
				})
			]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_3886_27657",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 32,
				height: 32,
				fill: "white",
				transform: "translate(0.867188 0.897217)"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip1_3886_27657",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 32,
				height: 24.6945,
				fill: "white",
				transform: "translate(1 4.81647)"
			})
		})
	] })]
});
export default SvgJcb;
